(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/activity/assets/javascripts/activity.js') >= 0) return;  svs.modules.push('/widgets/activity/assets/javascripts/activity.js'); "use strict";

(function (svs) {
  'use strict';

  svs.widget = svs.widget || {};
  svs.widget.activity = svs.widget.activity || {};
  svs.widget.activity.init = svs.content.bannerService.init;
})(svs);
 })(window);